import { CopyIcon } from "@chakra-ui/icons";
import { Button, ButtonProps, Text } from "@chakra-ui/react";
import { useCallback } from "react";

import { useMessageToast } from "../../hooks";

export interface CopyButtonProperties extends Omit<ButtonProps, "onClick"> {
  data?: string;
}

export const CopyButton = ({ children, data, ...rest }: CopyButtonProperties): React.ReactElement => {
  const toast = useMessageToast();

  const handleClick = useCallback(
    async (e: any) => {
      e.stopPropagation();
      if (data != null) {
        await navigator.clipboard.writeText(data);
        toast({
          status: "success",
          title: "Copié !",
        });
      }
    },
    [data, toast],
  );

  return (
    <Button onClick={handleClick} {...rest}>
      {children ?? (
        <>
          <CopyIcon mr={1} />
          <Text>Copier</Text>
        </>
      )}
    </Button>
  );
};
